import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

// Outlined cube with a top face + center stem — the "Area View" toggle icon. Stroke-based, so it
// follows the button's text color via currentColor (fill is explicitly none).
const AreaViewIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 16 16'} {...props}>
    <svg width={16} height={16} viewBox={'0 0 16 16'} fill="none">
      <path d="M8.5 8.59888L8.5 2.00014" stroke="currentColor" strokeWidth={0.8} />
      <path d="M3.0021 11.3483L8.50105 8.59879L14 11.3483" stroke="currentColor" strokeWidth={0.8} />
      <path
        d="M3.30609 11.5001L8.13218 13.9132C8.3644 14.0293 8.6377 14.0293 8.86992 13.9132L13.696 11.5001C13.8823 11.407 14 11.2166 14 11.0083L14 5.08923C14 4.88098 13.8823 4.69055 13.696 4.5974L8.86992 2.18435C8.6377 2.06827 8.3644 2.06827 8.13218 2.18435L3.30609 4.5974C3.11978 4.69055 3.0021 4.88098 3.0021 5.08922L3.0021 11.0083C3.0021 11.2166 3.11978 11.407 3.30609 11.5001Z"
        stroke="currentColor"
        strokeWidth={0.8}
      />
    </svg>
  </SvgIcon>
)
export default AreaViewIcon
